import { useCallback } from 'react';

import { useBusinessToolStore } from 'store/useBusinessToolStore';
import {
  getSetBusinessPlanFocusedField,
  getSetBusinessPlanFocusedFieldAttribute,
  getSetBusinessPlanFocusedFieldId,
} from 'store/useBusinessToolStore/selectors';

export const useClearInstructions = () => {
  const setBusinessPlanFocusedField = useBusinessToolStore(getSetBusinessPlanFocusedField);
  const setBusinessPlanFocusedFieldId = useBusinessToolStore(getSetBusinessPlanFocusedFieldId);
  const setBusinessPlanFocusedFieldAttribute = useBusinessToolStore(getSetBusinessPlanFocusedFieldAttribute);

  const clearFocusedFieldHandler = useCallback(() => {
    // Getting rid of the Instructions on change of section
    setBusinessPlanFocusedField(null);
    setBusinessPlanFocusedFieldId(null);
    setBusinessPlanFocusedFieldAttribute(null);
  }, []);

  return clearFocusedFieldHandler;
};
